import { useState } from "react";
import ConflictErrorModal from "./ConflictErrorModal";
import { errorMessages } from "app";

const extractItems = error => {
  const body = error?.body ?? error?.response?.data ?? error?.response ?? error;

  return Array.isArray(body?.properties) ? body.properties : [];
};

const extractMessage = error => {
  const body = error?.body ?? error?.response?.data ?? error?.response ?? error;
  return errorMessages?.[body?.errorCode] || body?.message || error?.message || "Възникна грешка";
};

const useConflictErrorModal = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("Грешка");
  const [items, setItems] = useState([]);

  const handleConflictError = error => {
    const errorItems = extractItems(error);
    if (!errorItems.length) return false;

    setTitle(extractMessage(error));
    setItems(errorItems);
    setOpen(true);

    return true;
  };

  const onClose = () => {
    setOpen(false);
    setItems([]);
  };

  const ConflictErrorDialog = () => (
    <ConflictErrorModal
      open={open}
      title={title}
      items={items}
      onClose={onClose}
    />
  );

  return {
    handleConflictError,
    ConflictErrorDialog,
  };
};

export default useConflictErrorModal;
